import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const userIdProtectQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.userIdProtect,
    queryFn: API.user.getUserIdProtect,
    staleTime: Infinity,
  });
